<div class=" expansion-panel-body">
    <div *ngFor="let item of projectDetails; index as i">
      <app-expansion-panel-item 
        #expansionPanel
        [projectName]="item.name" 
        [isOpened]="isWorkSelected"
        (toggle)="togglePanel($event)">
        <div class="row currency-container">
          <div class="col-6">
            <div class="currency-title">5-Year Capital Needs</div>
            <div class="currency-content"> {{ item.fiveYearCapitalNeeds | currency : "USD" : "$" : "1.0-0" }} </div>
          </div>
          <div class="col-6">
            <div class="currency-title">20-Year Capital Needs</div>
            <div class="currency-content"> {{ item.twentyYearCapitalNeeds | currency : "USD" : "$" : "1.0-0" }} </div>
          </div>
        </div>
        <div class="projects-container">
          <button
            *ngFor="let project of item.projects"
            type="button"
            class="button button-underline list-group-item list-group-item-action skiptranslate"
            (click)="loadProject.emit(project.id)"
            >
            <span> {{ project.name | titleCasewithAvoidWords | simplifyWords}} </span>
          </button>
        </div>
      </app-expansion-panel-item>
    </div>
</div>
